import { Grid } from "@mui/material";
import { ButtonType, CommonButton } from "../buttons/CommonButton";

export type ActionButtonsType = {
  forSave?: boolean;
  btnType?: ButtonType;
  loading?: boolean;
  cancelable?: boolean;
  deletable?: boolean;
  onCancel?: () => void;
  onSubmit: () => void;
  onDelete?: () => void;
};
export const ActionButtons = ({
  forSave,
  btnType,
  loading,
  cancelable = true,
  deletable,
  onCancel,
  onSubmit,
  onDelete,
}: ActionButtonsType) => (
  <Grid item xs={12} sx={{ mt: 2 }} container justifyContent="flex-end">
    {cancelable && <CommonButton btnType="Cancel" onClickBtn={onCancel} />}
    <CommonButton
      btnType={forSave ? "Save" : btnType ?? "Replace"}
      onClickBtn={onSubmit}
      disabled={loading ?? false}
      sx={{ ml: 1 }}
    />
    {deletable && (
      <CommonButton
        btnType="Delete"
        onClickBtn={onDelete}
        disabled={loading ?? false}
        sx={{ ml: 1 }}
      />
    )}
  </Grid>
);
